<template>
    <div class="container">
        <div class="mainContainer">
            <div class="heading">
                Welcome to JioMart Ads
            </div>
            <div class="formContainer">
                <label class="formHeading">Please select seller or brand account to proceed</label>
                <div class="form">
                    <div class="label">Enter brand or seller ID </div>
                    <div class="content">
                        <input class="textbox" v-model="accountId" placeholder="Enter here" />
                        <p v-if="accountIdError" class="label" style="color: red">{{accountIdError}}</p>
                    </div>
                </div>
                <button class="submitBtn" @click="handleSubmit">View Account</button>
            </div>
            <div class="formContainer">
                <label class="formHeading">Frequently Asked Questions</label>
            </div>
        </div>
    </div>
</template>

<script>
import { getCookie, setCookie } from "@/services/campaignService";
import { mapActions } from 'vuex';

export default ({
    name: 'AccountSelection',
    data() {
        return {
            accountId: '',
            accountIdError: '',
        }
    },
    methods: {
        ...mapActions(['setSellerId']),
        validateAccountId() {
            const idPattern = /^[0-9]+$/;
            this.accountIdError = !idPattern.test(this.accountId) ? 'ID is invalid' : '';
        },
        handleSubmit() {
            this.validateAccountId();
            if(!this.accountIdError) {
                const role = getCookie('role');
                this.setSellerId(this.accountId);
                setCookie('sellerId', this.accountId);
                this.$router.go(`${role === 'SUPERADMIN' || role === 'OPS' ? '/admin' : ''}/campaigns`)
            } else {

            }
        },
    },
    mounted() {
        const sellerId = getCookie('sellerId');
        if(sellerId) {
            this.$router.push("/");
        }
    }
})
</script>

<style scoped>
.container {
    max-width: 100%;
    background: #F8F8F8;
}
.mainContainer {
    margin: 0px 20%;
    width: 60%;
}
.heading {
    padding: 20px 0px 20px 16px;
    background: white;
    font-family: 'Inter-Regular';
    font-size: 24px;
    font-weight: 700;
    line-height: 28.8px;
    text-align: left;
    color: #41434C;
    margin-bottom: 16px;
    margin-top: 8px;
}
.formContainer {
    background: white;
    font-family: 'Inter-Regular';
    padding: 24px 16px;
    margin-bottom: 16px;
}
.formHeading {
    font-size: 16px;
    font-weight: 600;
    line-height: 22.4px;
    color: #666666;
}
.label{
    font-weight: 400;
    font-size: 12px;
    line-height: 19.2px;
    color: #666666;
    margin-bottom: 12px;
    margin-top: 16px;
}
.content{
    height: 100%;
}
.textbox{
    width: 274px;
    padding: 12px 14px;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
}
.submitBtn {
    background: #2E31BE;
    border-radius: 4px;
    color: #FFFFFF;
    padding: 9.5px 16px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    border: none;
    height: 40px;
    margin-top: 24px;
}
</style>
